import script from "./NewChatView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewChatView.vue?vue&type=script&setup=true&lang=js"

import "./NewChatView.vue?vue&type=style&index=0&id=2f62be10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f62be10"]])

export default __exports__